import { AfterViewInit, Directive, ElementRef, EventEmitter, Output } from '@angular/core';

import { FeatureDetectionService } from '../../core/feature-detection.service';

@Directive({
    selector: '[ncgInViewport]',
    standalone: false,
})
export class InViewportDirective implements AfterViewInit {
    @Output() intersectOutput = new EventEmitter<{ isIntersecting?: boolean; notSupported?: boolean }>();

    private observer: IntersectionObserver;
    private options: IntersectionObserverInit;

    constructor(
        private readonly el: ElementRef,
        private readonly featureDetectionService: FeatureDetectionService
    ) {}

    ngAfterViewInit() {
        const element: HTMLElement = this.el.nativeElement;

        if (element && this.featureDetectionService.hasIntersectionObserver()) {
            this.options = {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0.5,
            };

            this.observer = new IntersectionObserver((entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        this.intersectOutput.emit({ isIntersecting: true });
                        this.observer.unobserve(entry.target);
                        this.observer.disconnect();
                    }
                }
            }, this.options);
            this.observer.observe(element);
        } else {
            this.intersectOutput.emit({ notSupported: true });
        }
    }
}
